import PropTypes from 'prop-types';
import Chip from '@mui/material/Chip';
import CircularProgress from '@mui/material/CircularProgress';

import { statusChipSx } from './tableChipStyles';

// ==============================|| TABLE STATUS CHIP ||============================== //

export default function TableStatusChip({
  active,
  label,
  loading = false,
  loadingLabel = 'Updating...',
  onClick,
  sx = {}
}) {
  const displayLabel = loading ? loadingLabel : label ?? (active ? 'Active' : 'Inactive');

  return (
    <Chip
      label={displayLabel}
      size="small"
      variant="filled"
      onClick={onClick}
      icon={
        loading ? (
          <CircularProgress size={14} sx={{ color: active ? '#fff !important' : '#1f5b40 !important' }} />
        ) : undefined
      }
      sx={{
        ...statusChipSx(active),
        cursor: onClick && !loading ? 'pointer' : 'default',
        '&.MuiChip-colorSuccess, &.MuiChip-colorWarning, &.MuiChip-colorError': {
          bgcolor: 'inherit',
          color: 'inherit',
          borderColor: 'inherit'
        },
        ...sx
      }}
    />
  );
}

TableStatusChip.propTypes = {
  active: PropTypes.bool,
  label: PropTypes.string,
  loading: PropTypes.bool,
  loadingLabel: PropTypes.string,
  onClick: PropTypes.func,
  sx: PropTypes.object
};
